import React from "react";
import { useTranslation } from "react-i18next";
import { useTaxonomy } from "library/utils/useTaxonomy";
import { CenteredCell } from "../../../components/styled";

interface VehicleTypeCellProps {
  vehicleTypeId?: number | null;
}

export const VehicleTypeCell: React.FC<VehicleTypeCellProps> = ({
  vehicleTypeId,
}) => {
  const { t } = useTranslation();
  const taxonomy = useTaxonomy();

  if (!vehicleTypeId) {
    return <CenteredCell>-</CenteredCell>;
  }

  // Look up the taxonomy item by ID
  const vehicleTypeTaxonomy = taxonomy?.VehicleType?.byId?.[vehicleTypeId];

  if (!vehicleTypeTaxonomy) {
    return <CenteredCell>{vehicleTypeId}</CenteredCell>;
  }

  // Translate the code (VehicleLegalType codes have translations)
  return (
    <CenteredCell>
      {t(vehicleTypeTaxonomy.code, vehicleTypeTaxonomy.code)}
    </CenteredCell>
  );
};
